import React, {useState, useEffect, useCallback } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Aside from '../components/Aside';
import ClipLoader from "react-spinners/ClipLoader";
//import { CircularProgressbar  } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables';


const UsersReport = () => {
   
	const [customers, setCustomers] = useState([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
        if (!loading && customers.length > 0) {
            const table = $('#customer-report').DataTable({
                order: [[4, 'desc']]
            });
            return () => table.destroy(); // cleanup before re-render
        }
    }, [loading, customers]);


	const populate = useCallback(() => {
		setLoading(true)
        const endpoint = process.env.REACT_APP_BASE_URL + '/users/remote';
        fetch(endpoint, {

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            "method": "POST",
            "body": JSON.stringify({"key_id" : process.env.REACT_APP_BASE_APIKEY})
        })
        .then(response => response.json())
        .then(response => { 
            if(response.error === true){
                setLoading(false)
            }else{
             	setCustomers(response.data)
				setLoading(false)
				console.log("Customers : " + JSON.stringify(response.data))
            }
           
        })
        .catch(err => {
            console.log(err);
            setLoading(false)
        });
    }, []);

	useEffect(() => {
		populate()
	},[populate]);
	

		
 	return (
    <>
   
  
    <div
		id="main-wrapper"
		data-layout="vertical"
		data-navbarbg="skin5"
		data-sidebartype="full"
		data-sidebar-position="absolute"
		data-header-position="absolute"
		data-boxed-layout="full"
    >
		<Header />
		<Aside page="allusers"/>
  	
		<div className="page-wrapper">
			<div className="page-breadcrumb">
				<div className="row">
					<div className="col-12 d-flex no-block align-items-center">
					<h4 className="page-title">Customers</h4>
					<div className="ms-auto text-end">
						<nav aria-label="breadcrumb">
						<ol className="breadcrumb">
							<li className="breadcrumb-item"><a href="/">Home</a></li>
							<li className="breadcrumb-item active" aria-current="page">
							Customers
							</li>
						</ol>
						</nav>
					</div>
					</div>
				</div>
			</div>
		
			<div className="container-fluid">
				<div className="row">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Customers List</h5>
							{
							loading ? 
							<ClipLoader
                                color="fff"
                                loading={loading}
                                size={10}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            /> : 
                            <div className="table-responsive">
                                <table
                                id="customer-report"
                                className="table table-striped table-bordered"
                                >
                                    <thead>
										<tr>
                                            <th>Name</th>
											<th>Email</th>
                                            <th>Provider</th>
											<th>Creation Type</th>
											<th>Creation Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
										{
											customers.map((item, i) => 
												<tr key={i}>
									
													<td>{item.member_name}</td>
													<td>{item.mail}</td>
													<td>{item.provider}</td>
													<td>{item.creation_type}</td>
													<td>{item.createdDate}</td>
												</tr>
											)
										}
                                    </tbody>
                                    <tfoot>
                                        <tr>
											<th>Name</th>
											<th>Email</th>
                                            <th>Provider</th>
											<th>Creation Type</th>
											<th>Creation Date</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
							}
                        </div>
                    </div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
	</>
  	);
}

export default UsersReport;
